/**
 *
 * @param url string | undefined
 * @returns Check if the given string is a valid IP address or URL
 */
export default function isIPAddress(url?: string): boolean {
  if (!url) return false;

  const unifiedRegex =
    /^(https?:\/\/)?((([a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*)\.[a-zA-Z]{2,63})|((\d{1,3}\.){3}\d{1,3}))(:\d{1,5})?(\/.*)?$/;

  return unifiedRegex.test(url);
}

export function isPublicIpAddress(url?: string): boolean {
  if (!url) return false;

  const unifiedRegex =
    /^(https?:\/\/)?((([a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*)\.[a-zA-Z]{2,63})|((\d{1,3}\.){3}\d{1,3}))(:\d{1,5})?(\/.*)?$/;

  if (!unifiedRegex.test(url)) return false;

  const ipMatch = url.match(/(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})/);
  if (!ipMatch) {
    return true; // It's a domain name, assume public
  }
  const ip = ipMatch[0];
  const parts = ip.split(".");

  return !(
    parts[0] === "10" ||
    parts[0] === "0" ||
    (parts[0] === "192" && parts[1] === "168") ||
    (parts[0] === "172" &&
      parseInt(parts[1], 10) >= 16 &&
      parseInt(parts[1], 10) <= 31) ||
    parts[0] === "127" ||
    (parts[0] === "169" && parts[1] === "254")
  );
}

// Validate if a string is a valid number
export function isValidNumber(value: string) {
  return !isNaN(Number(value));
}
